module.exports = __webpack_public_path__ + "static/conflict_card_img1@2x-d53cca59a5095de0e59238209bed2a3a.jpg";